<!-- SPINNER validacion de credenciales -->
<div class="spinner__loading">
    <mat-spinner></mat-spinner>
    <br>
    <h4 *ngIf="loadingMessage != ''" class="validating mt-4">{{ loadingMessage }}<span>.</span><span>.</span><span>.</span></h4>
</div>
